import { useTheme } from 'vuetify/lib/framework.mjs'

const isClosedPenState = penState => {
  return penState.state === 'penEmpty' || penState.state === 'closed'
}

const penStateColor = penState => {
  const theme = useTheme();
  if (penState.state === 'penFull') return theme.current.value.colors.success;
  if (penState.state === 'penEmpty') return theme.current.value.colors.primary;
  if (penState.state === 'closed') return theme.current.value.colors.grey;
  return theme.current.value.colors.error
}

const deadAnimalDifferenceColor = deadAnimalDifference => {
  const theme = useTheme();
  if (!deadAnimalDifference) return theme.current.value.colors.grey;
  
  const isUnderFivePercent = parseInt(deadAnimalDifference.percentage) < 10;
  const dangerColor = isUnderFivePercent ? theme.current.value.colors.warning : theme.current.value.colors.error;

  return deadAnimalDifference.isCurrentlyMore ? dangerColor : theme.current.value.colors.success;
};

export {
  isClosedPenState,
  penStateColor,
  deadAnimalDifferenceColor,
}